export default __webpack_public_path__ + "static/media/hero-right-2.db5d601b.jpg";